import React from "react";
import "../WildVegetable/wildvegetable.css";
import bannerImage from "../../assets/veg1.JPG"; 
import objectiveImage from "../../assets/rnabhajii.jpg";
import highlightImage from "../../assets/veg4.JPG";

const WildVegetableFestival = () => {
  return (
    <div className="wild-vegetable-page">
      {/* Banner Section */}
      <div className="banner-wild">
        <img src={bannerImage} alt="Wild Vegetable Festival Banner" />
        <h2>Ran Bhaji Thali</h2>
      </div>

      {/* Intro Paragraph */}
      <div className="intro">
        <p>
          The Wild Vegetable Festival, organized by the Tarunai Foundation in Salaiban, Buldana District, Maharashtra, is a unique initiative aimed at promoting wild vegetable conservation, traditional knowledge of cooking, and sustainable living. Held annually at the foot of the Satpuda Hills, the festival has become a platform for learning, sharing, and celebrating the ecological and cultural wealth of the region.
        </p>
      </div>

      {/* Festival Objectives Section */}
      <div className="festival-objectives">
        <div className="text">
          <h2>Festival Objectives</h2>
          <ul>
            <li><strong>Conservation of Rare Wild Vegetables:</strong> 
               <ul>
                <li>The festival focuses on protecting indigenous wild vegetables, many of which are at risk due to deforestation and loss of chemical farming practices.</li>
                <li>By showcasing these vegetables, the event encourages their cultivation and sustainable use in everyday life.</li>
               </ul>
             </li>
            <li><strong>Awareness of Medicinal Benefits:</strong>
                <ul>
                    <li>Experts, including botanists and traditional healers, conduct sessions highlighting the medicinal properties of wild vegetables.</li>
                    <li>These vegetables are known to boost immunity, aid digestion, and treat common ailments, forming an integral part of tribal medicine.</li>
                </ul> 
             </li>
            <li><strong>Promotion of Traditional Recipes:</strong>
               <ul>
                  <li>The event showcases a wide array of dishes prepared with wild vegetables, preserving age-old culinary practices while introducing new ways to use these ingredients.</li>
                  <li>Demonstrations and tastings offer a deep understanding of how these vegetables can be incorporated into modern diets.</li>
               </ul>
            </li>
            <li><strong>Cultural and Social Significance:</strong> 
               <ul>
                 <li>The festival brings attention to the Satpuda region’s tribal communities and their sustainable way of living.</li>
                 <li>Traditional music, dance, and attire are celebrated, creating a confluence of nature and culture.</li>
               </ul>
             </li>
          </ul>
        </div>
        <div className="image">
          <img src={objectiveImage} alt="Festival Objectives" />
        </div>
      </div>

      {/* Festival Highlights Section */}
      <div className="festival-highlights">
        <div className="image">
          <img src={highlightImage} alt="Festival Highlights" />
        </div>
        <div className="text">
          <h2>Festival Highlights</h2>
          <ul>
            <li><strong>Rare Wild Vegetable Exhibition:</strong> 
              <ul>
                <li>Displays of rare species integral to the region’s ecology.</li>
              </ul>
            </li>
            <li><strong>Workshops and Talks:</strong>
             <ul>
                <li>
                Sessions on biodiversity conservation, sustainable farming, and the ecological importance of wild vegetables. 
                </li>
             </ul>
            </li>
            <li><strong>Culinary Exploration:</strong> 
               <ul>
                   <li> Traditional recipes using wild vegetables are demonstrated, allowing participants to understand their preparation and taste their unique flavors.</li>
               </ul>
            </li>
            <li><strong>Biodiversity and Ecology:</strong>
               <ul>
                <li>The festival creates awareness about the interconnection between plants, wildlife, and humans in the Satpuda ecosystem.</li>
                <li>Creates awareness about the interconnection between plants, wildlife, and humans.</li>
               </ul>
            </li>
            <li><strong>Community Participation:</strong> 
               <ul>
                <li>Involvement of local tribal communities in sharing their knowledge, skills, and traditions.</li>
               </ul>
             </li>
          </ul>
        </div>
      </div>

      {/* Impact of the Festival */}
      <div className="festival-impact">
        <h2>Impact of the Festival</h2>
        <ul>
          <li><strong>Ecological Impact:</strong> Encourages sustainable use and conservation of natural resources.</li>
          <li><strong>Cultural Preservation:</strong> Safeguards the cultural identity of local communities.</li>
          <li><strong>Health Awareness:</strong> Promotes the use of medicinal plants for better health practices.</li>
          <li><strong>Community Development:</strong> Provides a platform for farmers and artisans, fostering economic and social growth.</li>
        </ul>
      </div>
    </div>
  );
};

export default WildVegetableFestival;
